import * as React from 'react';
import { createViewConfig } from '@sail/engine';
import { Input } from './Input';
import { useFormFieldProps, FormField } from './FormField';
import { useRadioFormAdapter } from './form/adapters/useRadioFormAdapter';
export const NativeRadioConfig = createViewConfig({
    props: {},
    name: 'NativeRadio',
    flattens: true
});
export const NativeRadio = NativeRadioConfig.createView((props)=>/*#__PURE__*/ React.createElement(Input, {
        type: "radio",
        ...props
    }), {
    // @ts-expect-error - Baseline property is deprecated
    css: {
        baseline: 'cap-middle object-middle',
        appearance: 'none',
        stack: 'z',
        display: 'inline',
        margin: 'space.0',
        height: 'space.175',
        width: 'space.175',
        cursor: 'pointer',
        borderRadius: 'rounded',
        keyline: 'border',
        backgroundColor: 'form',
        transition: 'box-shadow 240ms ease-in-out',
        alignX: 'center',
        alignY: 'center',
        ':focus': {
            focusRing: 'focus'
        },
        ':disabled': {
            cursor: 'default',
            backgroundColor: 'form.disabled'
        },
        '[aria-invalid="true"]': {
            keyline: 'form.error'
        },
        // the "::before" element represents the outer ring of our checked state
        '::before': {
            content: '""',
            height: 'space.175',
            width: 'space.175',
            borderRadius: 'rounded',
            alignSelfX: 'stretch'
        },
        ':checked::before': {
            backgroundColor: 'form.accent',
            keyline: 'form.accent',
            opacity: 1
        },
        ':checked:disabled::before': {
            backgroundColor: 'form.accent.disabled',
            keyline: 'form.accent.disabled'
        },
        ':not(:checked)::before': {
            opacity: 0
        },
        '[aria-invalid="true"]::before': {
            keyline: 'form.error'
        },
        '[aria-invalid="true"]:checked::before': {
            keyline: 'form.error'
        },
        // the "::after" element represents the inner dot of our checked state
        '::after': {
            content: '""',
            display: 'inline-block',
            width: 'space.75',
            height: 'space.75',
            borderRadius: 'rounded',
            backgroundColor: 'onForm.accent',
            transition: 'opacity 240ms ease-in-out, transform 240ms ease-in-out'
        },
        // animate the size of the dot
        ':checked::after': {
            opacity: 1,
            transform: 'scale(1)'
        },
        ':not(:checked)::after': {
            opacity: 0,
            transform: 'scale(1.25)'
        }
    }
});
export const RadioConfig = createViewConfig({
    props: {},
    name: 'Radio',
    flattens: true
});
/**
 * @external
 * @param autoFocus
 * @param defaultChecked
 * @param disabled
 * @param form
 * @param invalid
 * @param name
 * @param onChange
 * @param readOnly
 * @param required
 * @param tabIndex
 * @param value
 */ export const Radio = RadioConfig.createView((props)=>{
    const { valueAdapter, changeAdapter } = useRadioFormAdapter();
    const [fieldProps, controlProps] = useFormFieldProps(props, {
        valueProp: 'checked',
        valueAdapter,
        changeAdapter
    });
    return /*#__PURE__*/ React.createElement(FormField, {
        ...fieldProps,
        layout: "horizontal"
    }, /*#__PURE__*/ React.createElement(NativeRadio, {
        ...controlProps,
        inherits: props.subviews.input
    }));
});

//# sourceMappingURL=Radio.js.map